import { getBasePositionSetWithSegment, getBaseSignature } from "selectors/base"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { getViewType, getPeriod, getSelectedModelId, getIsExpanded, getIsActive, getCurrency, getPortfolioFxHedgeEnabled } from "modules/portfolio-root/selectors/portfolios"
import { getEarliestDate, getLatestDate } from "modules/portfolio-root/selectors/dates"
import { getStartDate, getPerformanceFetchStartDate, getEndDate, getSelectedDate, getAiSummaryStartDate } from "selectors/dates"
import { getSelectedViews, getDisplayAddView } from "selectors/factors"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { getOptions, getSelectedOption } from "./selectors/options"
import { getFilteredData, getCategoryItemsSubset } from "./selectors/data"
import { getDisplayType, getAvailableSelectViewFactors } from "./selectors/items"
import { getFileName } from "./selectors/file"
import { getFirstPerformanceDate, getDatesAdjusted, getMetricType, getPassthroughResourcesStatus } from "./selectors/performance"
import { getSegment } from "modules/analyze-header/selectors/segment"
import { getFiltersVisible } from "modules/analyze-header/selectors"
import { getIsOpPro } from "modules/account-root/selectors"
import { MODEL_METADATA_QUERY } from "resources/models"
import { getIsRfrAttributionEnabled } from "selectors/features"
import { getResidualAttributionSummarySubquery } from "helpers/residualAttribution"

export default createModule({
  view,
  externalProps: (state, props) => ({
    portfolioId: state.global.selected.portfolio,
    fxHedgeEnabled: getPortfolioFxHedgeEnabled(state, props),
    account: state.global.selected.account,
    modelId: getSelectedModelId(state, props),
    startDate: getStartDate(state, props),
    fetchStartDate: getPerformanceFetchStartDate(state, props),
    aiSummaryStartDate: getAiSummaryStartDate(state, props),
    endDate: getEndDate(state, props),
    selectedDate: getSelectedDate(state, props),
    viewType: getViewType(state, props),
    isActive: getIsActive(state, props),
    base: getBasePositionSetWithSegment(state, props),
    baseSignature: getBaseSignature(state, props),
    segment: getSegment(state, props),
    expand: getIsExpanded(state, props),
    currency: getCurrency(state, props),
    isRfrAttributionEnabled: getIsRfrAttributionEnabled(state),
  }),
  required: ["account", "portfolioId", "modelId"],
  data: [{
    resource: "analyzePerformance",
    as: null,
    passthrough: true,
    url: ({ modelId, portfolioId, endDate, base, isActive, baseSignature, fetchStartDate, segment, expand, currency, fxHedgeEnabled, isRfrAttributionEnabled }) => {
      return {
        id: `analyzePerformance-${modelId}${portfolioId}${fetchStartDate}${endDate}${isActive}${baseSignature}${JSON.stringify(segment)}${expand}${currency}${fxHedgeEnabled}${isRfrAttributionEnabled}`,
        query: `query ($modelId: String!, $portfolioId: String!, $from: Date!, $to: Date!, $base: [PositionSetInput], $segment: Segment, $expand: Boolean) {
          model (id: $modelId) {
            simulation (positionSet: {
              type: PORTFOLIO,
              id: $portfolioId,
              segment: $segment,
              expand: $expand
            }, from: $from, to: $to, base: $base, interval: AUTO) {
              performance {
                date
                totalReturn {
                  cumulativePercent
                  cumulativeCurrency
                }
                attribution {
                  summary {
                    factors {
                      cumulativePercent
                      cumulativeCurrency
                    }
                    specific {
                      cumulativePercent
                      cumulativeCurrency
                    }
                    trading {
                      cumulativePercent
                      cumulativeCurrency
                    }
                    ${isRfrAttributionEnabled ? getResidualAttributionSummarySubquery(true) : ""}
                  }
                  factors {
                    id
                    category
                    name
                    return {
                      cumulativePercent
                      cumulativeCurrency
                    }
                  }
                }
              },
            }
          }
        }`,
        variables: {
          modelId,
          portfolioId,
          from: fetchStartDate,
          to: endDate,
          base: isActive ? [base] : undefined,
          segment,
          expand,
        },
      }
    },
  },
  MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    ...state.modules.analyzePerformance,
    earliestDate: getEarliestDate(state, props),
    latestDate: getLatestDate(state, props),
    firstDate: getFirstPerformanceDate(state, props),
    data: getFilteredData(state, props),
    items: getCategoryItemsSubset(state, props),
    options: getOptions(state, props),
    fileName: getFileName(state, props),
    period: getPeriod(state, props),
    selectedOption: getSelectedOption(state, props),
    displayType: getDisplayType(state, props),
    filtersVisible: getFiltersVisible(state, props),
    isOpPro: getIsOpPro(state, props),
    datesAdjusted: getDatesAdjusted(state, props),
    selectedViews: getSelectedViews(state, props),
    displayAddView: getDisplayAddView(state, props),
    availableSelectViewFactors: getAvailableSelectViewFactors(state, props),
    metricType: getMetricType(state, props),
    passthroughResourcesStatus: getPassthroughResourcesStatus(state, props),
  }),
  actions: {
    ...Creators,
    setDate: PortfolioRootCreators.setDate,
    resetDate: PortfolioRootCreators.resetDate,
    setPeriod: PortfolioRootCreators.setPeriod,
    addSelectedView: PortfolioRootCreators.addSelectedView,
    removeSelectedView: PortfolioRootCreators.removeSelectedView,
    addNotification: notificationsCreators.add,
    openDialog: DialogCreators.open,
  },
})
